























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ChatModel, { ChatDados } from "@/models/Chat";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import firebase from "firebase";
import { UserDb } from "@/models/User";
import moment from "moment";
import ChatMessage, { AlinhamentoMensagem } from "@/components/Chat/Mensagem.vue";
import { MensagemChatDados } from "@/components/Chat/SingleChatController";
import { Color } from "vuetify/lib/util/colors";
import _debug from "debug";

const debug = _debug("Mediacao:components:Chat:Chat.vue");

const userModule = getModule(UserModule, store);

export interface MensagemChat extends MensagemChatDados {
    alinhamento: AlinhamentoMensagem;
}

@Component({
    components: { chatMessage: ChatMessage },
})
export default class ChatComponent extends Vue {
    @Prop() public carregando!: boolean;
    @Prop() public chats!: ChatModel[];
    @Prop({ default: "chats" }) public titulo!: string;
    @Prop({ default: true }) public mostraTopo!: boolean;
    @Prop() public mensagens!: MensagemChat[];
    @Prop({ default: true }) public chatEncerrado!: boolean;
    @Prop() public id!: string;
    @Prop({ default: "green" }) public color!: Color;
    private loading = false;
    private novaMensagem = "";
    private dialogUploadArquivos = false;
    private arquivosParaEnviar: File[] = [];
    private filesAccept = "image/*,video/*,.pdf,.xls,.xlsx,.doc,.docx";

    @Watch("mensagens", { immediate: false, deep: true })
    public onMensagensChanged(val: MensagemChat[], oldVal: MensagemChat[]) {
        if (val.length > oldVal.length) {
            const elem = document.getElementById(`chat-content-${this.id}`);
            const container = document.getElementById(`chat-container-${this.id}`);
            debug("Mensagens mudou, elem, containuer", elem, container);
            setTimeout(() => {
                if (elem && container) {
                    container.scrollTop = container.scrollHeight;
                }
            }, 200);
        }
    }

    private get isLoading() {
        return this.loading;
    }

    private get naoPodeEnviarMensagem() {
        return this.chatEncerrado || this.novaMensagem.length === 0;
    }

    private async created() {
        debug("ChatComponent");
    }

    private get mensagensOrdenadas() {
        //console.log("ordenando mensagens", this.mensagens);
        const mensagensSorted = this.mensagens.sort((a: MensagemChat, b: MensagemChat) => {
            return a.sortId! - b.sortId!;
        });
        //console.log("mensagens ordenadas", mensagensSorted);
        return mensagensSorted;
    }

    private enviarMensagem() {
        this.$emit("enviarMensagem", { id: this.id, mensagem: this.novaMensagem });
        this.novaMensagem = "";
    }

    private enviarArquivos() {
        //console.log("enviar mensagem", this.arquivosParaEnviar);
        const accepts = this.filesAccept.split(",");
        const arquivosAcceptedParaEnviar = this.arquivosParaEnviar.filter(file => {
            return accepts.some(accept => {
                if (accept.startsWith(".")) {
                    return file.name.endsWith(accept);
                } else {
                    const regex = new RegExp(accept);
                    return regex.test(file.type);
                }
            });
        });
        //console.log("arquivosAcceptedParaEnviar", arquivosAcceptedParaEnviar);
        this.$emit("enviarMensagemArquivo", { id: this.id, arquivos: arquivosAcceptedParaEnviar });
    }
}
